export default "__VITE_ASSET__CkqSThHL__"